import React, { createContext, useContext, useState } from 'react';

const SidebarAdminContext = createContext();

export const useSidebarAdmin = () => {
  const context = useContext(SidebarAdminContext);
  if (!context) {
    throw new Error('useSidebarAdmin must be used within SidebarAdminProvider');
  }
  return context;
};

export const SidebarAdminProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(prev => !prev);
  };

  return <SidebarAdminContext.Provider value={{ isOpen, setIsOpen, toggleSidebar }}>{children}</SidebarAdminContext.Provider>;
};
